module.exports = __webpack_public_path__ + "img/11f.38373e33.png";